const DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
const MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre',
    'novembre', 'décembre'];

const time = (minutes: string, hours: string) => `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;

/**
 * Programmation lisible d'un cron à 5 champs, pour les formes que produit `dmp-input-cron` (minute,
 * heure, jour, semaine, mois, année). Une autre forme est rendue telle quelle.
 */
export function cronLabel(cron: string): string {
    if (!cron) {
        return '';
    }
    let m: RegExpMatchArray;
    if ((m = cron.match(/^\*\/(\d+) \* \* \* \*$/))) {
        return `Toutes les ${m[1]} minutes`;
    }
    if (cron === '* * * * *') {
        return 'Toutes les minutes';
    }
    if ((m = cron.match(/^(\d+) \* \* \* \*$/))) {
        return `Toutes les heures, à la minute ${m[1]}`;
    }
    if ((m = cron.match(/^(\d+) (\d+) \* \* \*$/))) {
        return `Tous les jours à ${time(m[1], m[2])}`;
    }
    if ((m = cron.match(/^(\d+) (\d+) \* \* ([0-7])$/))) {
        return `Chaque ${DAYS[+m[3]]} à ${time(m[1], m[2])}`;
    }
    if ((m = cron.match(/^(\d+) (\d+) (\d+) \* \*$/))) {
        return `Le ${+m[3]} de chaque mois à ${time(m[1], m[2])}`;
    }
    if ((m = cron.match(/^(\d+) (\d+) (\d+) (\d+) \*$/)) && +m[4] >= 1 && +m[4] <= 12) {
        return `Chaque année le ${+m[3]} ${MONTHS[+m[4] - 1]} à ${time(m[1], m[2])}`;
    }
    return cron;
}
